import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';
import moment from 'moment';
import { v4 } from 'uuid';

class homeRetailOfferStore {

    // Properties

    @observable retailOffers = [];
    @observable retailOfferId = 0;
    @observable taskId = 0;
    @observable taskName = '';

    @observable title = '';
    @observable titleEnglish = '';
    @observable titleChinese = '';
    @observable titleChineseTraditional = '';
    @observable titleThai = '';
    @observable titleJapanese = '';
    @observable titleVietnamese = '';

    @observable briefDesc = '';
    @observable briefDescEnglish = '';
    @observable briefDescChinese = '';
    @observable briefDescChineseTraditional = '';
    @observable briefDescThai = '';
    @observable briefDescJapanese = '';
    @observable briefDescVietnamese = '';

    @observable description = '';
    @observable descriptionEnglish = '';
    @observable descriptionChinese = '';
    @observable descriptionChineseTraditional = '';
    @observable descriptionThai = '';
    @observable descriptionJapanese = '';
    @observable descriptionVietnamese = '';

    @observable price = 0;
    @observable originalPrice = 0;
    @observable imageUrl = '';
    @observable images = [];
    @observable startDate = undefined;
    @observable endDate = undefined;
    @observable showBannerOnly = false;

    @observable homeRetailOfferLoading = false;

    @action init() {
        this.retailOffers = [];

        return ApiCaller.RetailOffer.GetAll().then((retailOfferResponses) => {
            if (retailOfferResponses) {
                retailOfferResponses.map((retailOfferResponse) => {
                    retailOfferResponse.startDate = moment(retailOfferResponse.startDate).format("DD MMMM YYYY");
                    retailOfferResponse.endDate = moment(retailOfferResponse.endDate).format("DD MMMM YYYY");

                    return retailOfferResponse;
                });

                this.retailOffers = retailOfferResponses;
            }
        })
    }

    @action initAvailable() {
        return ApiCaller.RetailOffer.GetAllAvailable().then((retailOfferResponses) => {
            if (retailOfferResponses) {
                retailOfferResponses.map((retailOfferResponse) => {
                    retailOfferResponse.startDate = moment(retailOfferResponse.startDate).format("DD MMMM YYYY");
                    retailOfferResponse.endDate = moment(retailOfferResponse.endDate).format("DD MMMM YYYY");

                    return retailOfferResponse;
                });

                this.retailOffers = retailOfferResponses;
            }
        });
    }

    @action initRead(retailOfferId) {
        this.imageUrl = '';
        
        return ApiCaller.RetailOffer.GetById(retailOfferId).then((retailOfferResponse) => {
            if (retailOfferResponse) {
                this.retailOfferId = retailOfferResponse.retailOfferId;
                this.taskId = retailOfferResponse.taskId;
                this.taskName = retailOfferResponse.taskName;

                this.briefDesc = retailOfferResponse.briefDesc;
                this.briefDescEnglish = retailOfferResponse.briefDescLang.english;
                this.briefDescChinese = retailOfferResponse.briefDescLang.chinese;
                this.briefDescChineseTraditional = retailOfferResponse.briefDescLang.chineseTraditional;
                this.briefDescThai = retailOfferResponse.briefDescLang.thai;
                this.briefDescJapanese = retailOfferResponse.briefDescLang.japanese;
                this.briefDescVietnamese = retailOfferResponse.briefDescLang.vietnamese;

                this.description = retailOfferResponse.description;
                this.descriptionEnglish = retailOfferResponse.descriptionLang.english;
                this.descriptionChinese = retailOfferResponse.descriptionLang.chinese;
                this.descriptionChineseTraditional = retailOfferResponse.descriptionLang.chineseTraditional;
                this.descriptionThai = retailOfferResponse.descriptionLang.thai;
                this.descriptionJapanese = retailOfferResponse.descriptionLang.japanese;
                this.descriptionVietnamese = retailOfferResponse.descriptionLang.vietnamese;

                this.title = retailOfferResponse.title;
                this.titleEnglish = retailOfferResponse.titleLang.english;
                this.titleChinese = retailOfferResponse.titleLang.chinese;
                this.titleChineseTraditional = retailOfferResponse.titleLang.chineseTraditional;
                this.titleThai = retailOfferResponse.titleLang.thai;
                this.titleJapanese = retailOfferResponse.titleLang.japanese;
                this.titleVietnamese = retailOfferResponse.titleLang.vietnamese;

                this.price = retailOfferResponse.price;
                this.originalPrice = retailOfferResponse.originalPrice;
                this.imageUrl = retailOfferResponse.imageUrl || '';
                this.images = [];
                if (retailOfferResponse.imageUrl) {
                    try {
                        let imagesJson = JSON.parse(retailOfferResponse.imageUrl);
                        imagesJson.map(imageJson => {
                            return imageJson.isLoading = false;
                        });
                        this.images = imagesJson;
                    } catch {
                        this.images.push({
                            id: v4(),
                            url: retailOfferResponse.imageUrl,
                            isLoading: false
                        });
                    }
                }

                this.startDate = moment(retailOfferResponse.startDate).format("DD MMMM YYYY");
                this.endDate = moment(retailOfferResponse.endDate).format("DD MMMM YYYY");

                this.showBannerOnly = retailOfferResponse.showBannerOnly;
            }
        })
    }

    @action setHomeRetailOfferLoading(value) {
        this.homeRetailOfferLoading = value;
    }

    @action resetData() {
        this.images = [];
        this.imageUrl = '';
        this.title = '';
        this.titleEnglish = '';
        this.titleChinese = '';
        this.titleChineseTraditional = '';
        this.titleThai = '';
        this.titleJapanese = '';
        this.titleVietnamese = '';

        this.description = '';
        this.descriptionEnglish = '';
        this.descriptionChinese = '';
        this.descriptionChineseTraditional = '';
        this.descriptionThai = '';
        this.descriptionJapanese = '';
        this.descriptionVietnamese = '';
    }
}

export default new homeRetailOfferStore()